export function request(userId, bets, channel, override, isFreeBet, selectedFreeBets) {
    return (dispatch, getState) => {
        dispatch({
            type: 'BETSLIP_PLACE_BET_REQUEST',
            channel,
            userId,
            bets,
            selections: getState().selections.get('items'),
            override,
            isFreeBet,
            selectedFreeBets
        });
    };
}

export function error(userId, { bets, combinations, possibilityError, errors }) {
    return {
        type: 'BETSLIP_PLACE_BET_ERROR',
        userId,
        bets,
        combinations,
        possibilityError,
        errors
    };
}

export function finish(userId, bets) {
    return {
        type: 'BETSLIP_PLACE_BET_FINISH',
        userId,
        bets
    };
}

export function clear(userId) {
    return {
        type: 'BETSLIP_PLACE_BET_CLEAR',
        userId
    };
}
